import intlTelInput from 'intl-tel-input';

export default class IntlPhone
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...IntlPhone.prototype.defaults, ...options }
        this.init()
    }

    init() {
        let options = {
            autoInsertDialCode: true,
            nationalMode: false,
            showSelectedDialCode: false,
            initialCountry: this.DOM.$el.dataset[this.options.attrEventCountryCode],
            utilsScript: "/assets/2.0/vendor/intl-tel-input-utils.js",
        }

        if (this.DOM.$el.dataset[this.options.attrCountryCode]) {
            options.initialCountry = this.DOM.$el.dataset[this.options.attrCountryCode];
        }

        if (this.DOM.$el.dataset[this.options.attrContainerClass]) {
            options.containerClass = this.DOM.$el.dataset[this.options.attrContainerClass];
        }

        this.iti = intlTelInput(this.DOM.$el, options)

        if (this.DOM.$el.value.length > 0) {
            this.iti.setNumber(this.DOM.$el.value)
        }

        this.DOM.$autocomplete = document.querySelector('.js-autoComplete')
        if (this.DOM.$autocomplete) {
            this.DOM.$autocomplete.addEventListener('autocomplete:select', this.onAutoCompleteSelect.bind(this))
        }

    }

    onAutoCompleteSelect(e) {
        if (e.detail.code === undefined || e.detail.flag === undefined) {
            return
        }

        if (this.DOM.$el.value.length < 5) {
            this.iti.setCountry(e.detail.code)
        }
    }
}

IntlPhone.prototype.defaults = {
    attrEventCountryCode: 'eventCountryCode',
    attrCountryCode: 'countryCode',
    attrContainerClass: 'containerClass'
}